import service from "@/utils/service.js"

/**
* 参数处理
* @param params 参数
*/
function tansParams(params) {
  let result = ''
  for (const propName of Object.keys(params)) {
    const value = params[propName]
    var part = encodeURIComponent(propName) + "="
    if (value !== null && value !== "" && typeof (value) !== "undefined") {
      if (typeof value === 'object') {
        for (const key of Object.keys(value)) {
          if (value[key] !== null && value[key] !== "" && typeof (value[key]) !== 'undefined') {
            let params = propName + '[' + key + ']'
            var subPart = encodeURIComponent(params) + "="
            result += subPart + encodeURIComponent(value[key]) + "&"
          }
        }
      } else {
        result += part + encodeURIComponent(value) + "&"
      }
    }
  }
  return result
}

const request = config=>{
  if (config.params) {
    let url = config.url + '?' + tansParams(config.params)
    url = url.slice(0, -1)
    config.url = url
  }
  return new Promise((resolve, reject) => {
    service.request({
      method: config.method || 'get',
      headers:config.headers ,
      url: config.baseUrl ||  config.url,
      data: config.data,

    }).then(res=>{
      resolve(res)
    }).catch(res=>{reject(res)})
  })
}
export default request



// WEBPACK FOOTER //
// ./src/utils/request.js